import req from './http.js'

// 店家登入
export const apiLogin = params => req('post', '/reservation/merchant/merchantLogin', params)

// Line登入
export const apiBindLineLogin = params => req('post', '/reservation/merchant/bindLineLogin', params)

// 解綁Line登出
export const apiLogout = params => req('post', '/reservation/merchant/merchantLogout', params)

// 取得核銷紀錄
export const apiGetServiceExecutionList = params => req('post', '/reservation/merchant/getExecutionEventList', params)

// 更新商家密碼/個人資料
export const apiUpdateSelfProfile = params => req('post', '/reservation/merchant/updateSelfProfile', params)

// 核銷日曆查詢
export const apiGetExecutionEvents = params => req('post', '/reservation/merchant/getExecutionEvents', params)

// 取得已核銷但還沒建請款單的票
export const apiGetUsedWaitProcessTickets = params => req('post', '/reservation/merchant/getUsedWaitProcessTickets', params)

// 取得請款單資料
export const apiGetPaymentRequestFormList = params => req('post', '/reservation/merchant/getPaymentRequestFormList', params)

// 建立請款單
export const apiCreatePaymentRequestForm = params => req('post', '/reservation/merchant/createPaymentRequestForm', params)

// 取得請款單詳細資料
export const apiGetPaymentRequestFormDetail = params => req('post', '/reservation/merchant/getPaymentRequestFormDetail', params)

// 下載請款單明細EXCEL檔案
export const apiGetPFDetailXls = params => req('post', '/reservation/merchant/getPFDetailXls', params)

// 更新請款單備註
export const apiUpdatePaymentRequestForm = params => req('post', '/reservation/merchant/updatePaymentRequestForm', params)

// 刪除請款單
export const apiCancelPaymentRequestForm = params => req('post', '/reservation/merchant/cancelPaymentRequestForm', params)

// 取得退票詳細資料
export const apiGetCancelDetail = params =>req('post', '/reservation/merchant/getCancelTicketDetail', params)

// 報表資料
export const apiGetProductPerformanceView = params => req('post', '/reservation/merchant/getProductPerformanceView', params)